import axios from "axios";

export const state = {
    reportloanpayments: [],
};

export const getters = {
    reportloanpayments: state => state.reportloanpayments,
};

export const mutations = {
    setReportLoansPayment(reportloanpayments, newValue) { state.reportloanpayments = newValue},
};

export const actions = {
    async fetchReportLoansPayment({ commit }) {
        await axios.get('/reportloanpayments').then(res => {
            commit('setReportLoansPayment', res.data.loans)
        })
    },
    async filterReportLoansPayment({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportloanpayments";
        await axios.post(url, formData).then((response) => {
            commit('setReportLoansPayment', response.data.loans)
        })
    },
};
